import { PageId } from 'constants/pages'

export const enum PageIdWoofzK9BlBg {
  DOG_AGE_K9_BL_BG = PageId.DOG_AGE_K9_BL_BG,
  DOG_SEX_K9_BL_BG = PageId.DOG_SEX_K9_BL_BG,
  DOG_BREED_K9_BL_BG = PageId.DOG_BREED_K9_BL_BG,
  DOG_BREED_ID_K9_BL_BG = PageId.DOG_BREED_ID_K9_BL_BG,
  URGE_K9_BL_BG = PageId.URGE_K9_BL_BG,
  CHALLENGES_K9_BL_BG = PageId.CHALLENGES_K9_BL_BG,
  URGE_1_K9_BL_BG = PageId.URGE_1_K9_BL_BG,
  LEASH_PULLING_K9_BL_BG = PageId.LEASH_PULLING_K9_BL_BG,
  URGE_LEASH_K9_BL_BG = PageId.URGE_LEASH_K9_BL_BG,
  DURING_WALK_K9_BL_BG = PageId.DURING_WALK_K9_BL_BG,
  URGE_NOT_ALONE_K9_BL_BG = PageId.URGE_NOT_ALONE_K9_BL_BG,
  AGRESSIVE_BEHAVIOR_K9_BL_BG = PageId.AGRESSIVE_BEHAVIOR_K9_BL_BG,
  TRIGGERS_K9_BL_BG = PageId.TRIGGERS_K9_BL_BG,
  URGE_2_K9_BL_BG = PageId.URGE_2_K9_BL_BG,
  BEHAVIOR_ISSUES_K9_BL_BG = PageId.BEHAVIOR_ISSUES_K9_BL_BG,
  DOG_ACT_K9_BL_BG = PageId.DOG_ACT_K9_BL_BG,
  DOG_OFF_AT_HOME_K9_BL_BG = PageId.DOG_OFF_AT_HOME_K9_BL_BG,
  REWARDS_K9_BL_BG = PageId.REWARDS_K9_BL_BG,
  IGNORE_COMMANDS_K9_BL_BG = PageId.IGNORE_COMMANDS_K9_BL_BG,
  COMMANDS_61_K9_BL_BG = PageId.COMMANDS_61_K9_BL_BG,
  COMMANDS_62_K9_BL_BG = PageId.COMMANDS_62_K9_BL_BG,
  COMMANDS_63_K9_BL_BG = PageId.COMMANDS_63_K9_BL_BG,
  URGE_3_K9_BL_BG = PageId.URGE_3_K9_BL_BG,
  PREPARE_SCREEN_K9_BL_BG = PageId.PREPARE_SCREEN_K9_BL_BG,
  DOG_PROFILE_K9_BL_BG = PageId.DOG_PROFILE_K9_BL_BG,
  URGE_REVIEWED_K9_BL_BG = PageId.URGE_REVIEWED_K9_BL_BG,
  PREPARE_FLOW_K9_BL_BG = PageId.PREPARE_FLOW_K9_BL_BG,
  EMAIL_K9_BL_BG = PageId.EMAIL_K9_BL_BG,
  NEWSLETTER_URGE_K9_BL_BG = PageId.NEWSLETTER_URGE_K9_BL_BG,
  SCRATCH_SCREEN_K9_BL_BG = PageId.SCRATCH_SCREEN_K9_BL_BG,
  SUBSCRIPTIONS_K9_BL_BG = PageId.SUBSCRIPTIONS_K9_BL_BG,
  CHAT_UPSELL_K9_BL_BG = PageId.CHAT_UPSELL_K9_BL_BG,
  UPSELL_K9_BL_BG = PageId.UPSELL_K9_BL_BG,
  UPSELL_FEEDING_GUIDE_K9_BL_BG = PageId.UPSELL_FEEDING_GUIDE_K9_BL_BG,
  UPSELL_EMOTIONAL_SUPPORT_K9_BL_BG = PageId.UPSELL_EMOTIONAL_SUPPORT_K9_BL_BG,
  DOWNLOAD_K9_BL_BG = PageId.DOWNLOAD_K9_BL_BG,
  ACCOUNT_K9_BL_BG = PageId.ACCOUNT_K9_BL_BG,
}
